import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import {
  isFetchingKeywordsCount,
  isAddingTrackedKeywords,
  getTrackedKeywordsCount,
  getSelectedDomainKeywords,
  isChangingSeoDb,
  keywordsBeingDeleted,
} from "../../store/tracked_keywords/selectors";
import {
  getSelectedWebsiteRegionalDatabase,
  getSelectedWebsiteDomain,
  getSelectedWebsiteGuid,
} from "../../store/tracked_websites/selectors";
import { updateSettings } from "../../store/tracked_websites/operations";
import {
  fetchTrackedKeywordsCount,
  fetchTrackedKeywords,
  changeKeywordsSeoDb,
  addTrackedKeywordsAndCheckStatus,
} from "../../store/tracked_keywords/operations";
import { fetchRegionalDatabases } from "../../store/regional_databases/operations";
import { getRegionalDatabases } from "../../store/regional_databases/selectors";
import { getMaxKeywordsNo } from "../../store/sales/selectors";
import KeywordsTab from "../../components/DashboardSettings/KeywordsTab";

export class Keywords extends Component {
  constructor(props) {
    super(props);

    this.handleChangeSeoDb = this.handleChangeSeoDb.bind(this);
  }

  componentDidMount() {
    this.props.fetchTrackedKeywordsCount();
    this.props.fetchRegionalDatabases();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.domain !== this.props.domain) {
      this.props.fetchTrackedKeywords(this.props.selectedWebsiteGuid, this.props.domain);
    }
  }

  handleChangeSeoDb(domain, newSeoDb) {
    this.props.changeKeywordsSeoDb(domain, newSeoDb, "reload_tracked_keywords");
    let settings = { seo_db: newSeoDb };
    this.props.updateSettings(domain, settings, "changeSeoDb", "reload_tracked_keywords");
  }

  render() {
    return (
      <KeywordsTab
        isFetchingKeywordsCount={this.props.isFetchingKeywordsCount}
        isAddingTrackedKeywords={this.props.isAddingTrackedKeywords}
        keywordsCount={this.props.keywordsCount}
        maxKeywordsNo={this.props.maxKeywordsNo}
        keywords={this.props.keywords}
        keywordsBeingDeleted={this.props.keywordsBeingDeleted}
        seoDb={this.props.seoDb}
        domain={this.props.domain}
        regionalDatabases={this.props.regionalDatabases}
        isChangingSeoDb={this.props.isChangingSeoDb}
        changeSeoDb={(domain, newSeoDb) => this.handleChangeSeoDb(domain, newSeoDb)}
        addTrackedKeywords={this.props.addTrackedKeywordsAndCheckStatus}
        deleteKeyword={this.props.deleteKeyword}
        push={this.props.push}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isFetchingKeywordsCount: isFetchingKeywordsCount(state),
  isAddingTrackedKeywords: isAddingTrackedKeywords(state),
  keywordsCount: getTrackedKeywordsCount(state),
  keywords: getSelectedDomainKeywords(state),
  keywordsBeingDeleted: keywordsBeingDeleted(state),
  maxKeywordsNo: getMaxKeywordsNo(state),
  selectedWebsiteGuid: getSelectedWebsiteGuid(state),
  domain: getSelectedWebsiteDomain(state),
  seoDb: getSelectedWebsiteRegionalDatabase(state),
  regionalDatabases: getRegionalDatabases(state),
  isChangingSeoDb: isChangingSeoDb(state),
});

export default connect(mapStateToProps, {
  fetchTrackedKeywordsCount,
  fetchTrackedKeywords,
  fetchRegionalDatabases,
  changeKeywordsSeoDb,
  updateSettings,
  addTrackedKeywordsAndCheckStatus,
  push,
})(Keywords);
